/**
 * Created by r4zi4l on 09.02.2021
 */

const Map2dAdviceOpenFogLogic = function (options) {
    Map2dAdviceBaseLogic.call(this, options);

    this.arrow = options && options.arrow;
};

Map2dAdviceOpenFogLogic.prototype = Object.create(Map2dAdviceBaseLogic.prototype);
Map2dAdviceOpenFogLogic.prototype.constructor = Map2dAdviceOpenFogLogic;

Map2dAdviceOpenFogLogic.prototype.findMove = function () {
    for (let i = 0; i < this.targets.length; ++i) {
        const fogBlock = Map2d.currentMap.fogs.blocks[this.targets[i]];

        if (fogBlock && fogBlock.head && fogBlock.state === FogBlock.CANOPEN) {
            return {
                cells: [cc.p(fogBlock.head.x, fogBlock.head.y)],
                arrow: this.arrow ? cc.p(fogBlock.head.x, fogBlock.head.y) : undefined,
                fogView: ["openfog"]
            };
        }
    }
};
